import LoginPage from 'components/LoginPage';
import i18n from 'i18n';
import React from 'react';
import { privacyLink, ethicsLink } from 'utils/helpers';
import useWindowDimensions from 'hooks/useWindowWidth';
import ForgotPasswordForm from './components/ForgotPasswordForm';

const ForgotPassword = () => {
  const { width } = useWindowDimensions();
  const image =
    width < 960
      ? '/images/login/mobileImage.png'
      : '/images/login/login1WithLogo.png';
  return (
    <React.Fragment>
      <LoginPage
        logoHeaderUrl="/images/AutoSkyLogoColorido.svg"
        backgroundImageUrl={image}
        links={[
          {
            name: i18n.t('PRIVACY_POLICY_KEY'),
            url: privacyLink[i18n.language],
          },
          {
            name: i18n.t('CODE_OF_ETHICS_KEY'),
            url: ethicsLink[i18n.language],
          },
        ]}
      >
        <ForgotPasswordForm language={i18n.language} />
      </LoginPage>
    </React.Fragment>
  );
};

export default ForgotPassword;
